// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"de5a58d8","453":"fd2f0c4a","796":"34154718"}[chunkId] + ".chunk.js";
};